import type { Location } from "../api";

export interface LocationPicker {
    element: HTMLElement;
    getValue: () => number;
}

export function createLocationPicker(locations: Location[], selectedId?: number): LocationPicker {
    let selected = selectedId ?? defaultLocationId(locations);

    const root = document.createElement("div");
    root.className = "filter-chips";
    root.setAttribute("role", "radiogroup");
    root.setAttribute("aria-label", "Storage zone");

    const options = new Map<number, HTMLButtonElement>();

    for (const loc of locations) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = `chip${loc.id === selected ? " active" : ""}`;
        btn.dataset.locationId = String(loc.id);
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", loc.id === selected ? "true" : "false");
        btn.textContent = loc.name;

        btn.addEventListener("click", () => select(loc.id));
        options.set(loc.id, btn);
        root.appendChild(btn);
    }

    function select(id: number): void {
        selected = id;
        options.forEach((btn, locId) => {
            const active = locId === id;
            btn.classList.toggle("active", active);
            btn.setAttribute("aria-checked", active ? "true" : "false");
        });
    }

    return {
        element: root,
        getValue: () => selected,
    };
}

function defaultLocationId(locations: Location[]): number {
    const pantry = locations.find((loc) => loc.name.toLowerCase() === "pantry");
    return pantry?.id ?? locations[0]?.id ?? 0;
}
